import { ICountry } from "../../constants/countries";
import { ICompanyOutlet } from "../../redux/companyOutlet/companyOutlet.types";
import { ISecurityGroup } from "../../redux/security/security.types";
import { ISubscriptionPlan } from "../../redux/subscription/subscription.types";
import { IUserProfile } from "../../redux/UserProfileList/userProfile.types";

export enum userRoles {
  ADMIN = "ADMIN",
  USER = "USER",
  None = "None",
  SUPERADMIN = "SUPERADMIN",
  ENR_ADMIN = "ENR_ADMIN",
  OWNER = "OWNER",
  WHATSAPPADMIN = "WHATSAPPADMIN",
  WHATSAPPUSER = "WHATSAPPUSER",
  MANAGER = "MANAGER",
  FINANCE = "FINANCE",
}

export interface IDecodedJWTToken {
  LOGO: string;
  COMPANY_NAME: string;
  company_outlet_uuid: string;
  full_name: string;
  user_fact_unique_id: number;
  user_uuid: string;
  company_outlet_timezone: string;
  email: string;
  role_uuid: string;
  role_value: string;
  branch_uuid: any[];
  internal_enr_user: any;
  iat: number;
  exp: number;
  subscribed_plan?: ISubscriptionPlan;
  gst_percentage: string
  default_country: string
}

// export interface IAuthUserCompanyOutlet {
//   company_outlet_uuid: string;
//   company_outlet_name: string;
// }

export interface IAuthContextUser {
  first_name: string
  last_name: string
  full_name: string;
  name: string
  userId: number;
  email: string;

  role: keyof typeof userRoles;
  userUuid: string;
  role_value: string;
  affilated_company_outlet_uuids: ICompanyOutlet[];
  shared_emails: any[]
  mobile: string
}

export type IWhatsappServiceProvider = "META" | "BAILEY" | null

export interface IAuthContextState {
  user: IAuthContextUser;
  twoFactorData: {
    userFactId: number;
  };
  app_info: {
    company_name: string;
    company_logo: string;
  };
  isLogin: boolean;
  sessionCount: number;
  token: string | null;
  company_outlet_timezone: string;
  force_logout: boolean;
  date: Date;
  subscribed_plan: ISubscriptionPlan | null;
  security: ISecurityGroup[]
  gst_percentage: string
  external_auth: IAuthContextState | null
  userSettings: IUserSettings[]
  isSimDialingEnabled: boolean
  country: ICountry
}

export interface ILoginResponseData {
  force_logout: boolean;
  isOTPPreview: boolean;
  sessionCount: number;
  token: string;
  user: IUserProfile;
}

export interface ILoginResponse {
  data: ILoginResponseData;
  message: string;
}

export interface IUserSettings {
  user_settings_unique_id: number
  user_settings_uuid: any
  master_company_outlet_env_uuid: string
  user_uuid: string
  setting_value: string
  status: string
  company_outlet_uuid: string
  created_by_uuid: any
  created_by_name: any
  modified_by_uuid: any
  modified_by_name: any
  create_ts: any
  insert_ts: string
  env_name: string
  env_key: string
  value_datatype: string
  configuration_for: string
  is_encrypted: number
  show_only_to_enr_admin: number
}

export interface IWhatsappService {
  isMultiple: boolean
  selectedService: IWhatsappServiceProvider
  serviceProviders: string[]
  whatsappNumber: string
}

export interface IAuthContext extends IAuthContextState {
  login: (
    emailOrUsername: string,
    password: string,
    onSuccess: (isOTPPreview: boolean, user: IAuthContextUser) => void,
    onError: (message: string) => void,
  ) => void;
  signup: (
    data: any,
    onSuccess: () => void,
    onError: (message: string) => void,
  ) => void;
  resendOTP: () => void;
  verifyOTP: (
    otp: string,
    onSuccess: () => void,
    onError: (message: string) => void,
  ) => void;
  forgotPassword: (
    email: string,
    otp_for: string,
    onSuccess: () => void,
    onError: (message: string) => void,
  ) => void;
  setNewPassword: (
    email: string,
    otp: string,
    new_password: string,
    onSuccess: () => void,
    onError: (message: string) => void,
  ) => void;
  logout: () => void;
  logoutFromAllDevices: () => void;
  addUserName: (name: string) => void;
  otherUserLogin: (newState: IAuthContextState, // Complete user data including security
    onComplete: (isSuccess: boolean, error?: string) => void,
  ) => void;
  updateUserData: (userData: IAuthContextState) => void;
  saveSignupData: (
    data: any,
    onSuccess?: (isOTPPreview: boolean, user: IAuthContextUser) => void,
    onError?: (message: string) => void,
  ) => void;
  checkUserSession: () => void;
  getActiveAuth: () => IAuthContextState;
  isExternalLogin: boolean;
  whatsappService: IWhatsappService
  fetchUserProfile: () => void
}

